// Czech

export default {
  component: {

    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `otevřená do ${date}` : ''),
    },
    interview: {
      title: 'Odpovědět na videopohovor',
      submit: 'Odeslat odpovědi a dokončit pohovor',
      continueLater: 'Pokračovat později',
      startInterview: 'Zahájit pohovor',
      duplicateError: 'Tohoto pohovoru jste se už zúčastnili. Dostali jste email z adresy invitations@recright.com. Odkaz, který obsahuje, můžete použít k pokračování v pohovoru.',
      confirmSubmitHeader: 'Nezodpověděli jste všechny otázky pohovoru',
      confirmSubmitContent: 'Opravdu chcete tento pohovor skončit?',
      confirmSubmitContentWarning: 'Poté už nebudete mít možnost své odpovědi doplnit.',
      submitInterviewHeader: 'Odeslat odpovědi na pohovor',
      submitInterviewContent: 'Určitě chcete odpovědi na pohovor odeslat?',
      confirmSubmitButton: 'Odeslat odpovědi a dokončit pohovor',
      preview: 'Náhled videootázek si můžete zobrazit zde.',
      requiredQuestionsNotAnswered: 'Před odesláním prosím odpovězte na všechny povinné otázky.',

      withdrawLink: 'Už o tuto pracovní pozici nemáte zájem? Odstupte z procesu zde.',
    },

    personalInterview: {
      title: 'Select time for an appointment',
      description: [
        'You have been invited to an appointment.',
        'Please select a time slot that suits you best.',
      ],
      position: 'Position:',
      location: 'Location:',
      time: 'Time:',
      timezoneNotice: [
        'Please keep in mind that the times are shown in your timezone.',
        'Your timezone appears to be:',
        'The appointment timezone is:',
      ],
      success: {
        title: 'Thank you',
        description: 'You have successfully scheduled a meeting',
        linkDescription: [
          'You can add the calendar invitation to your own calendar below.',
          'Or you can copy the link to your calendar app:',
        ],
        link: 'Add the calendar invitation to your calendar',
      },
    },

    interviewForm: {
      name: 'Jméno',
      city: 'Rodné město',
      email: 'E-mail',
      link: 'Odkaz',
      phone: 'Telefonní číslo',
      legendBasicInfo: 'Základní informace',
      placeholderName: 'Zadejte své jméno',
      placeholderEmail: 'Zadejte svůj email',
      placeholderPhone: 'Zadejte svůj telefon',
      placeholderCity: 'Zadejte své město, kde žijete',
      placeholderLink: 'Přidejte odkaz, například svůj profil na LinkedInu.',
      legendAttachments: 'Přílohy',
      legendAdditionalFields: 'Další informace',
      required: 'Položky označené * hvězdičkou jsou povinné.',
    },

    sequencedInterview: {
      networkTest: {
        audio: 'Audio',
        video: 'Video',
        yes: 'Ano',
        no: 'Ne',
        supported: 'Podporováno',
        quality: 'Kvalita',
        header: 'Test síťového připojení a zařízení',
        description: 'Teď spustíme test, abychom se ujistili, že vaše síťové připojení a hardware nutný k pohovoru (kamera a mikrofon) fungují, jak mají. Na vyzvání prosím testu dovolte použití jak kamery, tak mikrofonu, a ujistěte se, že kamera není zakrytá. Test bude trvat asi 30 vteřin. Doporučujeme, abyste během testu hardwaru mluvili.',
        inProgress: 'Probíhá testování...',
        networkTestResults: 'Výsledky testu sítě',
        qualityTestResults: 'Výsledky testu kvality',
        testPassedQuality: 'Test kvality úspěšný',
        testFailedQuality: 'Test kvality neúspěšný',
        testPassedNetwork: 'Test sítě úspěšný',
        testFailedNetwork: 'Test sítě neúspěšný',
        startTest: 'Spustit test',
        startInterview: 'Zahájit pohovor',
        testAgain: 'Otestovat znova',
        confirmWarning: 'Na začátku videopohovoru budete automaticky přesměrováni na první otázku. Po zobrazení otázky se přesunete k přípravě.',
        confirmTitle: 'Chystáte se zahájit pohovor',
        confirmText: 'Před každou otázkou budete mít k dispozici chvíli na přípravu odpovědi. Po přípravě budete mít určitý časový limit na zodpovězení otázky. Svou odpověď můžete odeslat i před uplynutím limitu.',
        confirmText2: 'Po odeslání odpovědi vás to přesune na další otázku, dokud budou nějaké zbývat.',
        confirmText3:
          'Vezměte prosím na vědomí, že po nahrání odpovědi na otázku máte 30 sekund na opakování odpovědi, pokud je opakování pro danou otázku povoleno. Pokud během této doby 30 sekund nezahájíte opakování, bude vaše aktuální odpověď automaticky odeslána a budete přesměrováni na další otázku.',
        goodLuck: 'Zhluboka se nadechněte – všechno dobře dopadne. Hodně štěstí!',
        qualityRating: {
          excellent: 'Výborná',
          good: 'Dobrá',
          fair: 'Přijatelná',
          poor: 'Neuspokojivá',
          bad: 'Špatná',
        },
      },
      questionAnswerView: {
        title: title => `Odpověď pro pohovor ${title}`,
        question: 'Otázka',
        submitAndNext: 'Odeslat a další',
        submitSuccess: 'Video úspěšně odesláno!',
        skipText: 'Začít nahrávat',
        stop: 'Stop',
        submitAndFinish: 'Odeslat a dokončit pohovor',
        retake: 'Natočit video znova',
        take: 'Natočit video',
        takesLeft: 'Zbývá pokusů o natočení',
        skipTextQuestion: 'Připraveni? Pokračujte dále',
        retakeConfirmTitle: 'Jste si jistý/á, že chcete zopakovat odpověď na tuto otázku?',
        retakeConfirmSubmit: 'Ano, spusťte opakování.',
        submitInfoForward: 'K automatickému odeslání aktuální odpovědi a posunu vpřed dojde za',
        submitInfoForward2: 'sekund.',
        nonAnswerableText: 'Tato zpráva nevyžaduje odpověď. Po této zprávě budete přesměrováni přímo na další otázku.',
        nonAnswerableVideo: 'Toto video nevyžaduje odpověď. Po tomto videu budete přesměrováni přímo na další otázku.',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `Na odpověď na otázku máte ${answerMinutes} minut a ${answerSeconds} sekund.`,
      },
      publisher: {
        toNextQuestion: timer => `Přesun na další otázku za ${timer}`,
        recordingStarts: timer => `Nahrávání začne za ${timer}`,
      },
      errors: {
        tooManyConnections: 'Toto připojení bylo uzavřeno, jelikož již máte připojení otevřeno na jiné kartě nebo v jiném okně.',
        unsupportedBrowser: 'Váš prohlížeč tuto operaci bohužel nepodporuje. Použijte prosím jiný prohlížeč.',
        networkError: 'Bez připojení k internetu.',
        reconnecting: 'Připojení bylo přerušeno. Pokoušíme se o nové připojení.',
        generalError: 'Něco se nepovedlo. Aktualizuje prosím stránku a zkuste to znova.',
        allowMediaDevicesError: 'Této operaci se nepodařilo získat mediální zařízení (kameru nebo mikrofon). Ujistěte se prosím, že jste prohlížeči povolili používat vaši kameru a mikrofon.',
        noAvailableDevicesError: 'Nenašli jsme kameru nebo mikrofon.',
        initPublisherError: 'Operace se nezdařila z důvodu chyby. Ujistěte se, že jste prohlížeči povolili používat kameru a mikrofon, že je nepoužívá jiná aplikace, a zkuste to znova.',
      },
      browserInfo: {
        browserSupportTitle: 'Podpora prohlížečů',
        supportedBrowsers: 'Tento test a pohovor podporují nejnovější verze prohlížečů Chrome, Firefox, Safari a Edge.',
        mobileSupported: 'Podporované prohlížeče na mobilním zařízení',
        android: 'Android: Google Chrome (nejnovější verze), Firefox (nejnovější verze)',
        iOS: 'iOS: Safari (nejnovější verze)',
        latestVersion: 'Ujistěte se prosím, že používáte nejnovější verzi prohlížeče. To aby všechno proběhlo hladce.',
        freezeInstruction: 'Pokud se nahrávání videa nespustí nebo obrazovka nahrávání zůstane černá, obnovte stránku.',
        unsupportedOnIos: 'Vypadá to, že používáte nepodporovaný prohlížeč na iOS. Použijte prosím Safari.',
        ieUnsupported: 'Vypadá to, že používáte Internet Explorer. Internet Explorer bohužel není prohlížečem podporovaným pro tento test a pohovor. Použijte prosím jiný prohlížeč.',
        qualityTestNotSupported: 'Testování hardwaru bohužel není podporováno prohlížečem, který používáte. Můžete přistoupit k pohovoru bez otestování audia a videa, případně použít jiný prohlížeč.',
      },
      reconnectSuccess: 'Podařilo se znova připojit!',
      continue: 'Pokračovat',
    },

    withdraw: {
      title: 'Už o tuto pracovní pozici nemáte zájem?',
      description: 'Odstupte z náborového procesu.',
      buttonText: 'Odstoupit z náborového procesu',
      thankYouTitle: 'Děkujeme!',
      thankYouText: 'Informovali jste náborového pracovníka, že o tuto pozici už nemáte zájem.',
      confirm: 'Určitě chcete odstoupit z náborového procesu? Po odstoupení už nebudete moci odpovědět na tento pohovor ani na žádný jiný související s touto pozicí.',
    },
  },

  page: {
    embeddedProfileInterview: {
      submit: 'Odeslat',
      continue: 'Pokračovat',
      supportCenter: 'Recright Help Center',
      thankYou:
        'Děkujeme vám za vaši videoodpověď! Spojíme se s vámi v dohledné budoucnosti!',
    },

    supportLink: 'support@recright.com',

    finished: {
      title: 'Děkujeme vám za účast na pohovoru!',
      reopenDescription: 'Jestliže jste tento pohovor uzavřeli omylem, buďte bez obav! Můžete ho znovu uzavřít kliknutím na tlačítko níže!',
      reopenButtonText: 'Znovuotevřít pohovor',
      description1: 'Výborně, zodpověděli jste všechny otázky a vaše odpovědi byly odeslány příjemci.',
      descriptionsupport: mailto => `Jestli jste tento pohovor uzavřeli omylem, ozvěte se prosím našim službám zákazníkům na ${mailto} a my váš pohovor znovu otevřeme.`,
      descriptionfeedback: 'Vaše zkušenost je pro nás důležitá. Jaká byla vaše zkušenost s odpovídáním na videopohovor? Jak byste naši službu vylepšili? Sdělte nám svůj názor.',
      feedbackbutton: 'Řekněte nám, co si myslíte!',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },
    messages: {
      title: 'Osobní zpráva',
    },

    closed: {
      title: 'Pohovor byl dokončen nebo pohovor skončil',
      description: 'Videopohovor, ke kterému jste byli pozváni, buď už skončil, nebo jste ho dokončili.',
      publicTitle: 'Interview has ended',
      publicDescription: 'The video interview has already ended.',
    },
    saved: {
      title: 'Teď je váš videopohovor uložený.',
      description: 'Až si budete přát ve videopohovoru pokračovat, použijte odkaz, který jste původně dostali v emailu. Až se vrátíte, už natočené videoodpovědi budou na svém místě. Hodně štěstí se sháněním práce!',
      remember: 'Až odpovědi na pohovor zodpovíte, nezapomeňte je odeslat náboráři.',
      deleteHistory: 'Jestli videopohovor děláte na veřejném počítači, nezapomeňte vymazat historii procházení. Váš pohovor tak bude v bezpečí.',
    },
    unpublished: {
      title: 'Pohovor zatím nebyl otevřen',
      publishTime: publishTime => `Pohovor se otevře v ${publishTime}`,
    },
  },
}
